// src/App.js
import { BrowserRouter as Router, Routes, Route, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import Menu from "./components/Menu";
import AuditoriaChat from "./pages/AuditoriaChat";
import SearchBar from "./components/SearchBar";
import Login from "./Login";
import "./App.css";

import SolicitudesComerciantes from "./pages/SolicitudesComerciantes";
import PagoSimulado from "./pages/PagoSimulado";
import SendEmailForm from "./components/SendEmailForm";
import GestionUnidadesVenta from "./pages/GestionUnidadesVenta";
import BusquedaFacetas from "./pages/BusquedaFacetas";
import SynonymsManager from "./pages/SynonymsManager";
import MeiliDashboard from "./pages/MeiliDashboard";
import TestEmail from "./pages/TestEmail";

// Usa rutas relativas para que funcionen en el mismo dominio (local o VPS)
const API_BASE = "/api";

// ==============================
// Página de Comerciantes (home)
// ==============================
function Comerciantes() {
  const navigate = useNavigate();
  const [comerciantes, setComerciantes] = useState([]);
  const [usuario, setUsuario] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);

  const [editando, setEditando] = useState(null);
  const [editNombre, setEditNombre] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editTelefono, setEditTelefono] = useState("");
  const [editTipoNegocio, setEditTipoNegocio] = useState("");
  const [editConfiguracionExtra, setEditConfiguracionExtra] = useState("");
  const [editLocalidad, setEditLocalidad] = useState("");
  const [editPatron, setEditPatron] = useState("");
  const [editPassword, setEditPassword] = useState("");

  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    telefono: "",
    password: "",
    patron: "",
    configuracion_extra: "",
    tipo_negocio: "",
    localidad: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    // Comprobar sesión
    fetch(`${API_BASE}/check_session.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          setUsuario(data.usuario);
          setAuthenticated(true);
        } else {
          navigate("/login");
        }
      })
      .catch(() => navigate("/login"));

    // Cargar comerciantes
    fetch(`${API_BASE}/getComerciantes.php`)
      .then((r) => r.json())
      .then((data) => setComerciantes(data))
      .catch((err) => console.error("❌ Error al obtener comerciantes:", err));
  }, [navigate]);

  const handleEdit = (comerciante) => {
    setEditando(comerciante.id);
    setEditNombre(comerciante.nombre);
    setEditEmail(comerciante.email);
    setEditTelefono(comerciante.telefono);
    setEditTipoNegocio(comerciante.tipo_negocio);
    setEditConfiguracionExtra(comerciante.configuracion_extra);
    setEditLocalidad(comerciante.localidad);
    setEditPatron(comerciante.patron);
    setEditPassword("");
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    const datosActualizados = {
      id: editando,
      nombre: editNombre,
      email: editEmail,
      telefono: editTelefono,
      tipo_negocio: editTipoNegocio,
      configuracion_extra: editConfiguracionExtra,
      localidad: editLocalidad,
      patron: editPatron,
      password: editPassword.trim() !== "" ? editPassword : undefined,
    };

    fetch(`${API_BASE}/editComerciante.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datosActualizados),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          let mensajeFinal = "✅ Comerciante actualizado correctamente.";
          if (editPassword.trim() !== "") {
            mensajeFinal += "\n🔒 Contraseña actualizada.";
          }
          alert(mensajeFinal);

          setComerciantes((prev) =>
            prev.map((c) => (c.id === editando ? { ...c, ...datosActualizados } : c))
          );
          setEditando(null);
          setEditPassword("");
        } else {
          alert("❌ Error: " + data.message);
        }
      })
      .catch((err) => {
        console.error("❌ Error al actualizar comerciante:", err);
        alert("❌ Ocurrió un error al intentar actualizar el comerciante.");
      });
  };

  const handleDelete = (id) => {
    if (!window.confirm("¿Seguro que quieres eliminar este comerciante?")) return;

    fetch(`${API_BASE}/deleteComerciante.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    })
      .then((r) => r.json())
      .then((data) => {
        alert(data.message);
        if (data.success) {
          setComerciantes((prev) => prev.filter((c) => c.id !== id));
        }
      })
      .catch((err) => console.error("❌ Error al eliminar comerciante:", err));
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/addComerciante.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();

      if (!data.success) {
        alert("❌ Error al agregar comerciante: " + data.message);
        return;
      }

      alert("✅ Comerciante agregado y email enviado correctamente.");

      setComerciantes((prev) => [...prev, { id: data.id, ...formData }]);
      setFormData({
        nombre: "",
        email: "",
        telefono: "",
        tipo_negocio: "",
        configuracion_extra: "",
        localidad: "",
        patron: "",
        password: "",
      });
    } catch (err) {
      console.error("❌ Error en el proceso:", err);
      alert("❌ Hubo un error al agregar el comerciante.");
    }
  };

  if (!authenticated) return null;

  return (
    <div className="App">
      <h1>Bienvenido, {usuario}</h1>

      <h2>Agregar Comerciante</h2>
      <form onSubmit={handleAdd}>
        {Object.keys(formData).map((key) => (
          <input
            key={key}
            type={key === "password" ? "password" : "text"}
            placeholder={key.charAt(0).toUpperCase() + key.slice(1)}
            value={formData[key]}
            onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
            required
          />
        ))}
        <button type="submit">Agregar Comerciante</button>

        <h2>Buscar Comerciantes</h2>
        <SearchBar comerciantes={comerciantes} setComerciantes={setComerciantes} />
      </form>

      <h2>Lista de Comerciantes</h2>
      <table border="1">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>Teléfono</th>
            <th>Tipo Negocio</th>
            <th>Configuración Extra</th>
            <th>Localidad</th>
            <th>Patrón</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {comerciantes.map((comerciante) => (
            <tr key={comerciante.id}>
              <td>{comerciante.nombre}</td>
              <td>{comerciante.email}</td>
              <td>{comerciante.telefono}</td>
              <td>{comerciante.tipo_negocio}</td>
              <td>{comerciante.configuracion_extra}</td>
              <td>{comerciante.localidad}</td>
              <td>{comerciante.patron}</td>
              <td>
                <button onClick={() => handleEdit(comerciante)}>Editar</button>
                <button onClick={() => handleDelete(comerciante.id)}>Eliminar</button>
                <button onClick={() => navigate(`/send-email/${comerciante.id}`)}>Enviar Email</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editando && (
        <div>
          <h2>Editar Comerciante</h2>
          <form onSubmit={handleUpdate}>
            <input type="text" value={editNombre} onChange={(e) => setEditNombre(e.target.value)} required />
            <input type="email" value={editEmail} onChange={(e) => setEditEmail(e.target.value)} required />
            <input type="text" value={editTelefono} onChange={(e) => setEditTelefono(e.target.value)} required />
            <input type="text" value={editTipoNegocio} onChange={(e) => setEditTipoNegocio(e.target.value)} required />
            <input type="text" value={editConfiguracionExtra} onChange={(e) => setEditConfiguracionExtra(e.target.value)} required />
            <input type="text" value={editLocalidad} onChange={(e) => setEditLocalidad(e.target.value)} required />
            <input type="text" value={editPatron} onChange={(e) => setEditPatron(e.target.value)} required />
            <input type="password" value={editPassword} onChange={(e) => setEditPassword(e.target.value)} placeholder="Nueva contraseña (opcional)" />
            <button type="submit">Guardar Cambios</button>
            <button type="button" onClick={() => setEditando(null)}>Cancelar</button>
          </form>
        </div>
      )}
    </div>
  );
}

// ==============================
// Layout con menú fijo
// ==============================
function Layout() {
  return (
    <>
      <Menu />
      <Outlet />
    </>
  );
}

// ==============================
// App (routes)
// ==============================
export default function App() {
  return (
    <Router>
      <Routes>
        {/* Rutas SIN menú */}
        <Route path="/login" element={<Login />} />
        <Route path="/pago-simulado/:nombre/:email" element={<PagoSimulado />} />
        <Route path="/send-email/:id" element={<SendEmailForm />} />
        <Route path="/test-email" element={<TestEmail />} />

        {/* Rutas CON menú */}
        <Route element={<Layout />}>
          <Route path="/" element={<Comerciantes />} />
          <Route path="/auditoria" element={<AuditoriaChat />} />
          <Route path="/busqueda" element={<BusquedaFacetas />} />
          <Route path="/meili/sinonimos" element={<SynonymsManager />} />
          <Route path="/meili/diagnostico" element={<MeiliDashboard />} />
          <Route path="/solicitudes" element={<SolicitudesComerciantes />} />
          <Route path="/unidades" element={<GestionUnidadesVenta />} />
        </Route>
      </Routes>
    </Router>
  );
}



